import { render, staticRenderFns } from "./ThankYouPriority.vue?vue&type=template&id=1aa298fc&scoped=true&"
import script from "./ThankYouPriority.vue?vue&type=script&lang=js&"
export * from "./ThankYouPriority.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouPriority.vue?vue&type=style&index=0&id=1aa298fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa298fc",
  null
  
)

export default component.exports